import { render, staticRenderFns } from "./manageTable.vue?vue&type=template&id=471c196b&"
import script from "./manageTable.vue?vue&type=script&lang=js&"
export * from "./manageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports